import {
  Grid,
  Typography,
  CardContent,
  CardHeader,
  useTheme,
  Card,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import {
  JobBody,
  JobTitle,
  StyledCard,
  StyledCardHeader,
} from "../../../styles/OurJobsStyles";
import { motion } from "framer-motion";
import { IngenierieQHSE } from "../../../data/TabsContent";

const Ingenierie = () => {
  return (
    <Box component={motion.div}>
      <JobTitle>QHSE</JobTitle>
      <Box mb={2}>
        <JobBody>
          <b> AFRIQUALEOS </b> accompagne ses clients selon les procédures de
          remboursement ou financement par les organismes tels que GIAC, OFPPT,
          Maroc PME, PME Logis ou BERD, pour les prestations suivantes :
        </JobBody>
      </Box>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        {IngenierieQHSE.map((item, index) => {
          return (
            <Grid key={index} item xs={12} sm={3}>
              <CardItem item={item} />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Ingenierie;

const CardItem = ({ item, open, setOpen }) => {
  const theme = useTheme();

  return (
    <StyledCard initial="hidden" animate="shown">
      <StyledCardHeader title={item.name} />
    </StyledCard>
  );
};
